export const transferGameLang = (lang) => {
  switch (lang) {
    case "en":
      return "en";
    case "zh_chs":
      return "cn";
    case "tw":
      return "tw";
    case "viet":
      return "viet";
    default:
      return "viet";
  }
};
